import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LayoutClass from "./pages/LayoutClass.js";
import NoPage from "./pages/NoPage.js";
import MainPage from "./pages/Main/MainPage.js";
import StatsPage from "./pages/Stats/StatsPage.js";
import LoginPage from "./pages/Login/LoginPage.js";
import AdminPage from "./pages/Admin/AdminPage.js";
import UserAdmin from "./pages/UserAdmin/UserAdmin.js";
import { ConfigProvider } from "antd";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<LayoutClass content={<MainPage />} />} />
        <Route path="stats" element={<LayoutClass content={<StatsPage />} />} />
        <Route path="login" element={<LayoutClass content={<LoginPage />} />} />
        <Route path="admin" element={<LayoutClass content={<AdminPage />} />} />
        <Route path="userAdmin" element={<LayoutClass content={<UserAdmin />} />} />
        <Route path="*" element={<LayoutClass content={<NoPage />} />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    theme={{
      components: {
        Select: {
          fontSize: 30,
          optionFontSize: 30,
          optionLineHeight: 1,
          optionHeight: 20,
        },
        Button: {
          controlHeightLG: 60,
          controlHeight: 50,
          controlHeightSM: 40,
          fontSizeLG: 60,
          fontSize: 50,
          fontSizeSM: 40,
          inputFontSizeLG: 60,
          inputFontSize: 50,
          inputFontSizeSM: 40,
          contentFontSizeLG: 50,
          contentFontSize: 40,
          contentFontSizeSM: 30,
          contentLineHeightLG: 2,
          contentLineHeight: 1,
          contentLineHeightSM: 0.5,
        },
        Input: {
          inputFontSizeLG: 60,
          inputFontSize: 50,
          inputFontSizeSM: 40,
          ontentLineHeightLG: 2,
          contentLineHeight: 1.5,
          contentLineHeightSM: 0.5,
          lineHeightLG: 2,
          lineHeight: 1.5,
        }
      },
      token: {
        controlHeightLG: 60,
        controlHeight: 50,
        controlHeightSM: 40,
        fontSizeLG: 60,
        fontSize: 50,
        fontSizeSM: 40,
        inputFontSizeLG: 60,
        inputFontSize: 50,
        inputFontSizeSM: 40,
        contentFontSizeLG: 50,
        contentFontSize: 40,
        contentFontSizeSM: 30,
        contentLineHeightLG: 2,
        contentLineHeight: 1,
        contentLineHeightSM: 0.5,
        lineHeightLG: 2,
        lineHeight: 1,
        fontFamily: "Sour Gummy, sans-serif",
      },
    }}
  >
    <App />
  </ConfigProvider>
);